import poll from './poll';

const pollAsync = ({
  condition = () => true,
  interval = 50,
  maxRetries = 200,
}) =>
  new Promise((resolve, reject) => {
    poll({
      callback: resolve,
      errorCallback: reject,
      condition,
      interval,
      maxRetries,
    });
  });

export default pollAsync;
